import React from "react";
import TrinsicStart from "../trinsic/TrinsicStart";
import {
  IconBolt,
  IconLock,
  IconHeart,
} from "@tabler/icons-react";
import useLocale from "../../../hooks/useLocale";

// Official BankID Norway logo hosted by Trinsic
const BankIdLogo = "https://content.trinsic.id/connect/integrations/no-bankid.png";

const BankIdNoStart = () => {
  const locale = useLocale("bankid-no");

  const bankIdFeatures = [
    { icon: IconBolt, text: locale.features.feature1 },
    { icon: IconLock, text: locale.features.feature2 },
    { icon: IconHeart, text: locale.features.feature3 },
  ];

  return (
    <TrinsicStart
      providerName="BANKID_NO"
      providerDisplayName="BankID"
      logo={BankIdLogo}
      logoWidth={48}
      title={locale.title}
      features={bankIdFeatures}
      poweredByText={locale.poweredBy}
      scanText={locale.scanToContinue}
      getStartedText={locale.getStarted}
    />
  );
};

export default BankIdNoStart;
